/**
 * @generated SignedSource<<6c655bf5d42bc04990088e48dc6b757f>>
 * @relayHash 82ae1b9c2b4e7b31e211094a4e3f4f3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type customFiltersQuery$variables = {
  boardId: string;
};
export type customFiltersQuery$data = {
  readonly boardScope: {
    readonly customFilters: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"card_projectSettingsCustomFilters_customFilterFragmentRef">;
    } | null | undefined>;
    readonly " $fragmentSpreads": FragmentRefs<"card_projectSettingsCustomFilters_boardScopeFragmentRef" | "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef">;
  };
};
export type customFiltersQuery = {
  response: customFiltersQuery$data;
  variables: customFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "boardId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "customFiltersQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "CustomFilter",
                "kind": "LinkedField",
                "name": "customFilters",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                  }
                ]
              },
              "action": "THROW",
              "path": "boardScope.customFilters"
            },
            {
              "kind": "FragmentSpread",
              "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
            },
            {
              "kind": "FragmentSpread",
              "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "customFiltersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "concreteType": "CustomFilter",
            "kind": "LinkedField",
            "name": "customFilters",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "concreteType": "FilterQuery",
                "kind": "LinkedField",
                "name": "filterQuery",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "sanitisedJql"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errors"
                  }
                ]
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "__typename"
              }
            ]
          },
          (v3/*: any*/),
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
    "metadata": {},
    "name": "customFiltersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2c5c0d030a87f3820766a2a896d71275";

export default node;
